<template>
  <!--  1px is a trick so the element gets a height which can be inherited. -->
  <div>
    <div style="display: flex">
      <div class="filterContainer"  v-if="$q.screen.width >= 768">
        <product-filters></product-filters>
      </div>
      <div style="flex: 1; background-color: #f5f5f5">
        <product-category-filter v-if="$q.screen.width >= 980"/>
        <div class="column calculatedContentAreaForRetailStore">
          <!-- Container status message -->
            <!-- Row with Sort, Count, and Pagination if resultCount > 0  -->
            <div style="display: flex; justify-content: center; margin-top: 4px; padding: 0 5px; height: 40px;" >
            <div style="display: flex; max-width: 1000px; width:100%; justify-content: space-between;" v-if="resultCount > 0">
              <div v-if="$q.screen.width < 768">
                <q-btn color="primary" dense outline icon="filter_alt" @click="showFilter = true" style="height: 100%;"/>
              </div>
              <div>
                <q-select v-model="orderBy" :options="orderByOptions" class="q-mr-lg" style="min-width:120px; display: inline-block;" dense outlined bg-color="white" label="Sort by"/>
              </div>
              <div class="text-bold" style="margin: auto 0; font-size: 18px;">
                  {{resultCount}} Items
              </div>
              <div v-if="maxPage > 1">
                <q-select dense v-model="currentPage" :options="paginationOptions" outlined v-if="$q.screen.width <= 900" bg-color="white" label="Page" style="width: 80px;"/>
                <div style="margin: 5px 0 0 0">
                  <q-pagination size="14px" v-model="currentPage" :max="maxPage" direction-links :max-pages="5" v-if="$q.screen.width > 900" />
                </div>
              </div>
            </div>
          </div>
          <!-- Row with No Items if resultCount == 0 -->
          <div class="text-h4" style="display: flex; justify-content: center; margin-top:30px" v-if="resultCount == 0">
            <p>No items found!</p>
          </div>

          <!-- Row with Products if resultCount > 0  -->
          <q-scroll-area class="col" ref="scrollAreaRef">
          <!-- <div class="col"> -->
            <div class="row" v-if="resultCount">
              <div class="col" style="margin-bottom: 20px;">
                <router-view :products="products" storeType="retail" :productCount="resultCount"></router-view>
                <div style="display: flex; justify-content: center; margin-top: 10px; padding: 0 5px; height: 40px;" >
                  <div style="display: flex; max-width: 1000px; width:100%; justify-content: end;" v-if="maxPage > 1">
                    <q-select dense v-model="currentPage" :options="paginationOptions" outlined v-if="$q.screen.width <= 900" bg-color="white" label="Page" style="width: 80px;"/>
                    <div style="margin: 5px 0 0 0">
                      <q-pagination size="14px" v-model="currentPage" :max="maxPage" direction-links :max-pages="5" v-if="$q.screen.width > 900" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          <!-- </div> -->
          </q-scroll-area>
        </div>
        <product-dialog storeType="retail"></product-dialog>
      </div>
    </div>

  <!-- Dialog on small screens show filter -->
  <q-dialog v-model="showFilter" position="left" full-height>
    <product-filters></product-filters>
  </q-dialog>

  </div>
</template>

<script>
import ProductDialog from '../../components/ProductDialog'
import ProductFilters from '../../components/ProductFilters'
import ProductCategoryFilter from '../../components/ProductCategoryFilter'
import gql from 'graphql-tag'
import { mapGetters } from 'vuex'
import EditCartMenu from '../../components/EditCartMenu'
import { formatCurrency } from '../../util/string'
import moment from 'moment'

export default {
  name: 'PageRetailProduct',
  components: {
    EditCartMenu,
    ProductDialog,
    ProductCategoryFilter,
    ProductFilters
  },
  apollo: {
    products () {
      return {
        query: gql`
          query products ($filter: ProductFilterInput, $limit: Int, $offset: Int, $orderBy: ProductsOrderByFieldInput, $descending: SortOrderInput) {
            products(filter: $filter, store: Retail, limit: $limit, offset: $offset, orderBy: $orderBy, descending: $descending) {
              products {
                id,
                name,
                reference,
                attributes,
                images {
                  url
                  name
                },
                urlSlug,
                description,
                skus {
                  id,
                  showInRetail,
                  retailPrice,
                  options,
                  stock,
                  previousStock,
                  stockLastUpdate,
                  createdAt,
                  updatedAt
                }
                createdAt,
                updatedAt
              },
              count
            }
          }
        `,
        // skip: () => !this.currentAccount,
        variables () {
          return {
            filter: this.productFilterGql,
            limit: this.pageSize,
            offset: (this.currentPage - 1) * this.pageSize,
            orderBy: this.orderBy?.toLowerCase(),
            descending: 'Ascending'
          }
        },
        update (result) {
          this.trk_products_loaded(result.products.products.length, result.products.count)
          this.resultCount = result.products.count
          return result.products.products
        },
        fetchPolicy: 'network-only',
        context: {
          headers: {
            uuid: this.currentUUID
          }
        },
        result (result) {
          this.$refs.scrollAreaRef.setScrollPosition('vertical', 0)
          this.maxPage = Math.ceil(result.data.products.count / this.pageSize)
        }
      }
    },
    activeCart () {
      return {
        query: gql`
          query activeCart ($id: ID!) {
            cart(id: $id) {
              id,
              name
              items {
                id,
                skuId,
                qty,
                sku {
                  id,
                  options,
                  retailPrice,
                  product {
                      id,
                      attributes
                  }
                }
              }
            }
          }
        `,
        variables () {
          return {
            id: this.activeCartId
          }
        },
        context: {
          headers: {
            uuid: this.currentUUID
          }
        },
        update: data => data.cart,
        error (error) {
          if (error.message === `GraphQL error: Cart with id ${this.activeCartId} does not exist.`) {
            return this.$store.dispatch('cart/createNewActiveCart', { input: { name: `Retail Cart ${moment().format('DD/MM/YY')}` }, storeType: 'retail' })
          }
        }
      }
    }
  },
  watch: {
    productFilterGql (a, b) {
      this.currentPage = 1
    },
    orderBy () {
      this.currentPage = 1
    }
  },
  computed: {
    ...mapGetters('filters', ['productFilterGql']),
    displayType () {
      return this.$route.path.split('/').slice(-1)[0]
    },
    currentUUID () {
      return this.$store.state.auth.currentUUID
    },
    currentAccount () {
      return this.$store.state.auth.currentAccount
    },
    activeCartId () {
      return (this.$store.state.auth.currentAccount) ? this.$store.state.auth.currentAccount.activeRetailCartId : this.$store.state.auth.currentGuest.activeRetailCartId
    },
    isLoggedIn () {
      return !!this.$store.state.auth.currentAccount
    },
    totalHolds () {
      return this.activeCart?.items?.reduce((p, c, i) => p + ((c.sku?.product?.attributes?.holds || 0) * Number(c.qty)), 0)
    },
    totalSets () {
      return this.activeCart?.items?.reduce((p, c, i) => p + Number(c.qty), 0)
    },
    totalCost () {
      return this.activeCart?.items?.reduce((p, c, i) => p + ((c.sku?.retailPrice || 0) * Number(c.qty)), 0)
    },
    paginationOptions () {
      return Array.from({ length: this.maxPage }, (v, k) => k + 1)
    }
  },
  methods: {
    trk_display_type (selection) {
      analytics.track('Product Display Type', {
        type: selection,
        storeType: this.$store.state.cart.currentStoreType
      })
    },
    trk_products_loaded (loadedQty, totalProducts) {
      analytics.track('Products Loaded', {
        loaded: loadedQty,
        total: totalProducts,
        secondsBetweenLoads: (Date.now() - this.loadedAt) / 1000,
        storeType: this.$store.state.cart.currentStoreType
      })
      // Reset date
      this.loadedAt = Date.now()
    },
    async fetchMore (done) {
      try {
        await this.$apollo.queries.products.fetchMore({
          variables: {
            offset: this.products.length
          },
          updateQuery: (previousQueryResult, { fetchMoreResult }) => {
            if (!previousQueryResult) {
              this.$apollo.queries.products.refetch()
              done()
              return null
            }
            if (!fetchMoreResult.products?.products?.length) {
              done(true)
              return previousQueryResult
            }
            done()
            return Object.assign({}, previousQueryResult, {
              products: {
                __typename: previousQueryResult.products.__typename,
                products: [...previousQueryResult.products.products, ...fetchMoreResult.products.products],
                count: previousQueryResult.products.count
              }
            })
          }
        })
      } catch (error) {
        done()
        this.$nextTick(() => {
          this.$apollo.queries.products.refetch()
        })
      }
    },
    formatCurrency: formatCurrency,
    setDisplayType (displayType) {
      this.$router.push(`/retail/${displayType}`)
    },
    productFilter (prod) {
      const searchTerm = this.$store.state.filters.search
      return this.productInStockFilter(prod) && (
        this.productNameFilter(prod, searchTerm) ||
        this.productReferenceFilter(prod, searchTerm) ||
        this.productAttributeFilter(prod, 'brand', searchTerm) ||
        this.productAttributeFilter(prod, 'range', searchTerm) ||
        this.productAttributeFilter(prod, 'material', searchTerm) ||
        this.productAttributeFilter(prod, 'size', searchTerm) ||
        this.productAttributeFilter(prod, 'grip', searchTerm)
        // this.productColourFilter(prod, searchTerm)
      )
    },
    productInStockFilter (prod) {
      if (!prod || !prod.skus) return true
      return prod.skus.length > 0
    },
    productNameFilter (prod, searchString) {
      if (!searchString || !prod || !prod.name) return true
      return prod.name.toLowerCase().includes(searchString.toLowerCase())
    },
    productReferenceFilter (prod, searchString) {
      if (!searchString || !prod || !prod.reference) return true
      return prod.reference.toLowerCase().includes(searchString.toLowerCase())
    },
    productAttributeFilter (prod, attributeName, searchString) {
      if (!searchString) return true
      if (!prod || !prod.attributes || !prod.attributes[attributeName]) return false
      return prod.attributes[attributeName].toLowerCase().includes(searchString.toLowerCase())
    },
    productColourFilter (prod, searchString) {
      if (!searchString || !prod || !prod.skus) return true
      return !!prod.skus.find(sku => (sku.options?.colour?.name || '').toLowerCase().includes(searchString.toLowerCase()))
    },
    skuData (row) {
      let data = {}
      row.skus.forEach(sku => {
        if ('colour' in sku.options) {
          if (!(sku.options.colour.group in data)) data[sku.options.colour.group] = 0
          data[sku.options.colour.group] += sku.stock
        }
      })
      return data
    }
  },
  data () {
    return {
      currentPage: 1,
      maxPage: 1,
      pageSize: 24,
      products: [],
      resultCount: 0,
      orderBy: 'Price',
      orderByOptions: ['Brand', 'Range', 'Name', 'Price', 'Newest'],
      thumbStyle: {
        right: '2px',
        borderRadius: '5px',
        backgroundColor: '#c5161c',
        width: '7px',
        opacity: 0.75
      },
      showFilter: false
    }
  }
}
</script>

<style >
  .filterContainer {
    width: 220px;
    background-color: white;
    border-right: 1px solid rgba(0, 0, 0, 0.05);
  }

  .calculatedContentAreaForRetailStore{

    @media (max-width: 8000px) {
      height: calc(100vh - 196px);
      /* min-height: calc(100vh - 196px); */
    }

    @media (max-width: 978px) {
      height: calc(100vh - 125px);
    }

    @media (max-width: 919px) {
      height: calc(100vh - 62px);

    }

    @media (max-width: 768px) {
      height: calc(100vh - 62px);
    }


    @media (max-width: 600px) {
      height: calc(100vh - 107px);
    }


  }

</style>
